import {useEffect, useState} from 'react';
import classNames from 'classnames';

import VectorIcon from '../VectorIcon';
import SignupStepContainer from '../SignupStepContainer.client';

import ReactModal from 'react-modal';
import {useAuthService} from '../../contexts/AuthServiceProvider.client';

interface SignupModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function SignupModal({
  isOpen,
  onRequestClose,
}: SignupModalProps) {
  const [isLoading, setIsLoading] = useState(false);

  const {signupStep} = useAuthService();
  useEffect(() => setIsLoading(true), [signupStep]);
  useEffect(() => {
    if (isLoading) {
      setTimeout(() => setIsLoading(false), 250);
    }
  }, [isLoading]);

  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__content modal-signup-inner default-modal"
      overlayClassName="modal modal_active modal-signup"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
    >
      <div
        role="button"
        tabIndex={-1}
        onClick={onRequestClose}
        className="default-modal__close js-modal-close"
      >
        <VectorIcon iconName="delete-x" />
      </div>
      <div
        className={classNames('default-modal__box', {loading: isLoading})}
        id="modal-signup-content"
      >
        <SignupStepContainer />
      </div>
    </ReactModal>
  );
}
